import React, { useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Image, Spinner, Nav } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link, useParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import config from "../../config";
import { formatNumber } from "../../Utils/utils";
import debounce from "lodash.debounce";

const NumberInput = ({ id, value, onChange }) => {
  return (
    <div className="gs-btn">
      <button
        onClick={() => onChange(id, value + 1)}
        className="incr"
        type="button"
        aria-label="Increment value"
      >
        +
      </button>
      <input
        id={id}
        type="number"
        value={value}
        min="0"
        onChange={(e) => onChange(id, parseInt(e.target.value) || 0)}
        aria-label="Number input"
      />
      <button
        onClick={() => onChange(id, value - 1)}
        className="decr"
        type="button"
        aria-label="Decrement value"
      >
        -
      </button>
    </div>
  );
};

const ViewSchedule = () => {
  const [courseid, setCourseid] = useState(null);
  const [coursename, setCoursename] = useState("");
  const [categorySlug, setCategorySlug] = useState("");
  const [currentSlug, setCurrentSlug] = useState("");

  const [coursescheduleData, setCoursescheduleData] = useState([]);
  const [dayType, setDayType] = useState("");

  const [total_schedule, setTotal_schedule] = useState(0);
  const [coursescheduleoffset, setCoursescheduleoffset] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { courseId } = useParams();

  // Fetch main ID and set course ID only once
  useEffect(() => {
    setCourseid(courseId);
  }, []);

  const fetchSchedule = useCallback(
    debounce((requestData) => {
      const apiUrl = `${config.API_BASE_URL}/course_schedule`;
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 1) {
            if (requestData.offset === 0) {
              setCoursescheduleData(response.data.course_schedule);
              setCategorySlug(response.data.category_seo_slug);
              setCurrentSlug(response.data.seo_slug);
            } else {
              setCoursescheduleData((prevSchedule) => [
                ...prevSchedule,
                ...response.data.course_schedule,
              ]);
            }
            setCourseid(response.data.id);
            setCoursename(response.data.name);
            setTotal_schedule(response.data.total_schedule);
          } else {
            setError("Failed to load content");
            console.error("Error:", response.message);
          }
          setLoading(false);
        })
        .catch((error) => {
          setError("Fetch error");
          console.error("Fetch Error:", error);
          setLoading(false);
        });
    }), // Debounce with 300ms delay
    []
  );

  useEffect(() => {
    if (courseid) {
      document.title = `View Schedule | Agile Seekers`;
      document.getElementById("bodywrap").className = "vischmain";

      fetchSchedule({
        id: courseid,
        day_type: dayType,
        offset: coursescheduleoffset,
      }); // Initial fetch
    }
  }, [courseid, fetchSchedule, dayType, coursescheduleoffset]);

  const handleDayTypeChange = (newDayType) => {
    if (newDayType === "all") {
      newDayType = ""
    }
    setDayType(newDayType);
    setCoursescheduleoffset(0); // Reset offset to 0

    // Fetch schedule with updated dayType and offset 0
    fetchSchedule({
      id: courseid,
      day_type: newDayType,
      offset: coursescheduleoffset,
    });
  };

  const courseschedule_handleViewMore = () => {
    const newOffset = coursescheduleoffset + 6;
    setCoursescheduleoffset(newOffset);

    fetchSchedule({ id: courseid, day_type: dayType, offset: newOffset });
  };

  const [values, setValues] = useState(1);

  // Handle changes in the input value
  const handleValueChange = (id, newValue) => {
    setValues((prevValues) => ({
      ...prevValues,
      [id]: Math.max(newValue, 0), // Prevent negative values
    }));
  };

  const SchedulesTabs = [
    {
      id: 1,
      eventKey: "all",
      title: "All",
    },
    {
      id: 2,
      eventKey: "weekday",
      title: "Weekday",
    },
    {
      id: 3,
      eventKey: "weekend",
      title: "Weekend",
    },
    // {
    //   id: 4,
    //   eventKey: "month",
    //   title: "Month",
    // },
  ];

  return (
    <>
      <Navbar />

      <section className="vs-box">
        <Container>
          <Row>
            <Col md={4} lg={3} className="ord2">

              <Row>
                <Col md={12}>
                  <Link to={`/${categorySlug}/${currentSlug}`} className="vs-back">
                    Back
                  </Link>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <div className="vs-off">
                    <div>
                      <h3>5% Off</h3>
                      <Link to="">
                        <Image
                          src={`${config.BASE_URL}/assets/images/copy.png`}
                          className="img-fluid"
                          alt="copy"
                        />
                      </Link>
                    </div>
                    <div className="cctxt">
                      <h5>Coupon code </h5>
                      <h6>"SPRING..."</h6>
                    </div>
                    <div className="ccofftxt">
                      <h5>Coupon expires </h5>
                      <h6>Next Tuesday</h6>
                    </div>
                  </div>

                  <div className="vs-google-review">
                    <div className="vgr-main">
                      <div className="vgr-img">
                        <Image
                          src={`${config.BASE_URL}/assets/images/google-review.png`}
                          className="img-fluid"
                          alt="google"
                        />
                      </div>
                      <div className="vgr-box">
                        <p>5/5</p>
                      </div>
                    </div>
                    <div className="vgr-side">
                      <div className="vs-enroll">
                        <div>
                          <div className="vs-en-left">
                            <p>5000 + Enrolled</p>
                          </div>
                          <div className="vs-en-right">
                            <Image
                              src={`${config.BASE_URL}/assets/images/rbl1.png`}
                              className="img-fluid"
                              alt="rbl1"
                            />
                            <Image
                              src={`${config.BASE_URL}/assets/images/rbl2.png`}
                              className="img-fluid"
                              alt="rbl2"
                            />
                            <Image
                              src={`${config.BASE_URL}/assets/images/rbl3.png`}
                              className="img-fluid"
                              alt="rbl3"
                            />
                            <Image
                              src={`${config.BASE_URL}/assets/images/rbl4.png`}
                              className="img-fluid"
                              alt="rbl4"
                            />
                            <Image
                              src={`${config.BASE_URL}/assets/images/rbl5.png`}
                              className="img-fluid"
                              alt="rbl5"
                            />
                            <Image
                              src={`${config.BASE_URL}/assets/images/rbl6.png`}
                              className="img-fluid"
                              alt="rbl6"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="vs-call">
                    <Link to="tel:+919143964396">
                      <Image
                        src={`${config.BASE_URL}/assets/images/cnt-phone.png`}
                        className="img-fluid"
                        alt="cnt-phone"
                      />
                      +91 91 4396 4396
                    </Link>
                  </div>
                </Col>
              </Row>

            </Col>

            <Col md={8} lg={9} className="vsb-right">
              <h2>{coursename}</h2>
              <Tabs
                defaultActiveKey="all"
                id="schtab"
                className="mb-3 schtab"
                onSelect={handleDayTypeChange}
              >
                {SchedulesTabs.map((SchedulesTab, index) => (
                  <Tab eventKey={SchedulesTab.eventKey} title={SchedulesTab.title} key={index}>
                    <Row className={"vsb-box"}>
                      <Col md={12}>
                        {loading ? (
                          <Col md={12} className="text-center">
                            <Spinner animation="border" variant="dark" />
                          </Col>
                        ) : error ? (
                          <Col md={12}> {error} </Col>
                        ) : coursescheduleData.length > 0 ? (
                          (SchedulesTab.eventKey === "all" || coursescheduleData.some(
                            (item) => SchedulesTab.title === item.day_type
                          )) ? (
                            <>
                              {coursescheduleData
                                .slice() // clone to avoid mutating original data
                                .sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
                                .map(
                                  (item, index) =>
                                    (SchedulesTab.eventKey === "all" || item.day_type === SchedulesTab.title) && (
                                      <div className="schbox" key={index}>
                                        <div className="scbone">
                                          <div className="scbonetop">
                                            <h3>
                                              {item.start_date} - {item.end_date}
                                            </h3>
                                            <div>
                                              <div className="scday">
                                                <Image
                                                  src={`${config.BASE_URL}/assets/images/${item.time_type}.png`}
                                                  className="img-fluid"
                                                  alt="day"
                                                />
                                                <p>{item.time_type}</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="sctime">
                                            <Image
                                              src={`${config.BASE_URL}/assets/images/sctime.png`}
                                              className="img-fluid"
                                              alt="sctime"
                                            />
                                            <p>
                                              IST {item.start_time} - {item.end_time}
                                            </p>
                                          </div>
                                          <div className="scbatch">
                                            <Image
                                              src={`${config.BASE_URL}/assets/images/scbatch.png`}
                                              className="img-fluid"
                                              alt="scbatch"
                                            />
                                            <p>
                                              Online Classroom - {item.online_class_room}
                                            </p>
                                          </div>
                                          <div className="scuser">
                                            <Image
                                              src={`${config.BASE_URL}/assets/images/scuser.png`}
                                              className="img-fluid"
                                              alt="scuser"
                                            />
                                            <p>{item.instructor_name}</p>
                                          </div>
                                        </div>
                                        <div className="scbtwo">
                                          <h3>{item.price_off}% Off</h3>
                                          <div>
                                            <h4>₹ {formatNumber(item.fee)}</h4>
                                            <h5>₹ {formatNumber(item.discount_fee)}</h5>
                                          </div>
                                        </div>
                                        <div className="scbthr">
                                          <NumberInput
                                            id={`gsbtn-${index}`}
                                            value={values[`gsbtn-${index}`] || 1}
                                            onChange={handleValueChange}
                                          />
                                        </div>
                                        <div className="scbfou">
                                          <Link
                                            to="/checkout"
                                            state={{
                                              course_id: courseid,
                                              course_name: coursename,
                                              course_schedule_id: item.id,
                                              course_fee: item.fee,
                                              course_qty: values[`gsbtn-${index}`],
                                            }}
                                          >
                                            Enroll
                                          </Link>
                                          {item.selling_fast === 1 ? (
                                            <div>
                                              <Image
                                                src={`${config.BASE_URL}/assets/images/rocket.png`}
                                                className="img-fluid"
                                                alt="rocket"
                                              />
                                              <p>Selling Fast</p>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    )
                                )}
                              {coursescheduleData.length < total_schedule && (
                                <Row>
                                  <Col md={12} className="lpvm-btn">
                                    <Link onClick={courseschedule_handleViewMore}>
                                      View More
                                    </Link>
                                  </Col>
                                </Row>
                              )}
                            </>
                          ) : (
                            <Col md={12} className="text-center">
                              <Spinner animation="border" variant="dark" />
                            </Col>
                          )
                        ) : (
                          <Col md={12}>
                            <p>Need a schedule that fits you? Let us customize it for you! Call or WhatsApp us at <a href="tel:+919143964396" target="_blank" rel="noopener noreferrer">+91 91 439 64396.</a> </p>

                          </Col>
                        )}
                      </Col>
                    </Row>
                  </Tab>
                ))}
              </Tabs>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default ViewSchedule;
